module.exports = __webpack_public_path__ + "img/card_origen.117c76a3.jpg";